import React from 'react';
import ProcedureTab from './ProcedureTab';
import { PROCEDURE_CATEGORIES } from '../../types/ProcedureTypes';

interface EmergencyTabProps {
    procedures: any[];
    loading: boolean;
    error: string | null;
    selectedProcedure: any;
    setSelectedProcedure: (procedure: any) => void;
    onRefresh?: () => void;
}

const EmergencyTab: React.FC<EmergencyTabProps> = (props) => {
    const config = {
        title: 'Emergency Procedures',
        description: 'Emergency response procedures and protocols',
        icon: 'fa-exclamation-triangle',
        category: PROCEDURE_CATEGORIES.EMERGENCY,
        columns: [
            {
                key: 'title',
                header: 'Type',
            },
            {
                key: 'shortDescription',
                header: 'Description',
            },
        ],
        isEmergency: true,
    };

    return <ProcedureTab config={config} {...props} />;
};

export default EmergencyTab;
